import { create } from 'zustand'

type Entity =
  | wowaudit.Guild
  | wowaudit.Community
  | wowaudit.Team
  | wowaudit.Character

type PrefetchedStore = {
  getData: <T extends Entity>(path?: string) => T | undefined
  data: Record<string, Entity>
}

const storePrefetchedData = () => {
  return Object.values(window?.prefetched_data || {}).reduce((acc, source) => {
    acc[source.path] = source
    return acc
  }, {} as Record<string, Entity>)
}

const usePrefetchedStore = create<PrefetchedStore>((set, get) => ({
  data: storePrefetchedData(),
  getData: <T extends Entity>(path?: string): T | undefined =>
    path ? (get().data[path] as T | undefined) : undefined,
}))

export default usePrefetchedStore
